import React, { VFC } from 'react';
import { useApi } from '../utils/api';
import { Linking, Text } from 'react-native';

type Props = {
  userId: string;
};

export const SendNewPassword: VFC<Props> = ({ userId }) => {
  const api = useApi();

  const requestSendNewPassword = async () => {
    if (confirm('Are you sure you want to send a system generated password to this user?')) {
      try {
        if (await api.sendNewPassword(userId)) {
          alert('A new password has been sent to the user');
        } else {
          alert('There was a problem sending a new password');
        }
      } catch {
        alert('There was a problem sending a new password');
      }
    }
  };

  return <Text onPress={requestSendNewPassword}>Send system-generated password</Text>;
};
